/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConfigurationDto } from '../model/';
// @ts-ignore
import type { ConfigurationUpdateDto } from '../model/';
// @ts-ignore
import type { UpdateCalculationEngineTypeDto } from '../model/';
// @ts-ignore
import type { UserAdminSettingCreateDto } from '../model/';
// @ts-ignore
import type { UserAdminSettingDto } from '../model/';
// @ts-ignore
import type { UserAdminSettingDtoPagedResultDto } from '../model/';
// @ts-ignore
import type { UserAdminSettingUpdateDto } from '../model/';
/**
 * UserAdminSettingApi - axios parameter creator
 * @export
 */
export const UserAdminSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemConfigurationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systemConfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCalculationEngineTypeDto} [updateCalculationEngineTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateCalculationEngineTypePost: async (updateCalculationEngineTypeDto?: UpdateCalculationEngineTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/updateCalculationEngineType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCalculationEngineTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigurationUpdateDto} [configurationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateSystemConfigurationPost: async (configurationUpdateDto?: ConfigurationUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/updateSystemConfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configurationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingGet: async (sorting?: string, skipCount?: number, maxResultCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/userAdminSetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserAdminSettingIdDelete', 'id', id)
            const localVarPath = `/api/userAdminSetting/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserAdminSettingIdGet', 'id', id)
            const localVarPath = `/api/userAdminSetting/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UserAdminSettingUpdateDto} [userAdminSettingUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingIdPut: async (id: number, userAdminSettingUpdateDto?: UserAdminSettingUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserAdminSettingIdPut', 'id', id)
            const localVarPath = `/api/userAdminSetting/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAdminSettingUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserAdminSettingCreateDto} [userAdminSettingCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingPost: async (userAdminSettingCreateDto?: UserAdminSettingCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/userAdminSetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAdminSettingCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAdminSettingApi - functional programming interface
 * @export
 */
export const UserAdminSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAdminSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemConfigurationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemConfigurationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAdminSettingApi.apiSystemConfigurationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCalculationEngineTypeDto} [updateCalculationEngineTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateCalculationEngineTypePost(updateCalculationEngineTypeDto?: UpdateCalculationEngineTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateCalculationEngineTypePost(updateCalculationEngineTypeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAdminSettingApi.apiUpdateCalculationEngineTypePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfigurationUpdateDto} [configurationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateSystemConfigurationPost(configurationUpdateDto?: ConfigurationUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateSystemConfigurationPost(configurationUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAdminSettingApi.apiUpdateSystemConfigurationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAdminSettingGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAdminSettingDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAdminSettingGet(sorting, skipCount, maxResultCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAdminSettingApi.apiUserAdminSettingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAdminSettingIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAdminSettingIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAdminSettingApi.apiUserAdminSettingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAdminSettingIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAdminSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAdminSettingIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAdminSettingApi.apiUserAdminSettingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UserAdminSettingUpdateDto} [userAdminSettingUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAdminSettingIdPut(id: number, userAdminSettingUpdateDto?: UserAdminSettingUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAdminSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAdminSettingIdPut(id, userAdminSettingUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAdminSettingApi.apiUserAdminSettingIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserAdminSettingCreateDto} [userAdminSettingCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAdminSettingPost(userAdminSettingCreateDto?: UserAdminSettingCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAdminSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAdminSettingPost(userAdminSettingCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserAdminSettingApi.apiUserAdminSettingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserAdminSettingApi - factory interface
 * @export
 */
export const UserAdminSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAdminSettingApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemConfigurationGet(options?: RawAxiosRequestConfig): AxiosPromise<ConfigurationDto> {
            return localVarFp.apiSystemConfigurationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCalculationEngineTypeDto} [updateCalculationEngineTypeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateCalculationEngineTypePost(updateCalculationEngineTypeDto?: UpdateCalculationEngineTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiUpdateCalculationEngineTypePost(updateCalculationEngineTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigurationUpdateDto} [configurationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateSystemConfigurationPost(configurationUpdateDto?: ConfigurationUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiUpdateSystemConfigurationPost(configurationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<UserAdminSettingDtoPagedResultDto> {
            return localVarFp.apiUserAdminSettingGet(sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUserAdminSettingIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<UserAdminSettingDto> {
            return localVarFp.apiUserAdminSettingIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UserAdminSettingUpdateDto} [userAdminSettingUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingIdPut(id: number, userAdminSettingUpdateDto?: UserAdminSettingUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<UserAdminSettingDto> {
            return localVarFp.apiUserAdminSettingIdPut(id, userAdminSettingUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserAdminSettingCreateDto} [userAdminSettingCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAdminSettingPost(userAdminSettingCreateDto?: UserAdminSettingCreateDto, options?: RawAxiosRequestConfig): AxiosPromise<UserAdminSettingDto> {
            return localVarFp.apiUserAdminSettingPost(userAdminSettingCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAdminSettingApi - object-oriented interface
 * @export
 * @class UserAdminSettingApi
 * @extends {BaseAPI}
 */
export class UserAdminSettingApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminSettingApi
     */
    public apiSystemConfigurationGet(options?: RawAxiosRequestConfig) {
        return UserAdminSettingApiFp(this.configuration).apiSystemConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCalculationEngineTypeDto} [updateCalculationEngineTypeDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminSettingApi
     */
    public apiUpdateCalculationEngineTypePost(updateCalculationEngineTypeDto?: UpdateCalculationEngineTypeDto, options?: RawAxiosRequestConfig) {
        return UserAdminSettingApiFp(this.configuration).apiUpdateCalculationEngineTypePost(updateCalculationEngineTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigurationUpdateDto} [configurationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminSettingApi
     */
    public apiUpdateSystemConfigurationPost(configurationUpdateDto?: ConfigurationUpdateDto, options?: RawAxiosRequestConfig) {
        return UserAdminSettingApiFp(this.configuration).apiUpdateSystemConfigurationPost(configurationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminSettingApi
     */
    public apiUserAdminSettingGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig) {
        return UserAdminSettingApiFp(this.configuration).apiUserAdminSettingGet(sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminSettingApi
     */
    public apiUserAdminSettingIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return UserAdminSettingApiFp(this.configuration).apiUserAdminSettingIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminSettingApi
     */
    public apiUserAdminSettingIdGet(id: number, options?: RawAxiosRequestConfig) {
        return UserAdminSettingApiFp(this.configuration).apiUserAdminSettingIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UserAdminSettingUpdateDto} [userAdminSettingUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminSettingApi
     */
    public apiUserAdminSettingIdPut(id: number, userAdminSettingUpdateDto?: UserAdminSettingUpdateDto, options?: RawAxiosRequestConfig) {
        return UserAdminSettingApiFp(this.configuration).apiUserAdminSettingIdPut(id, userAdminSettingUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserAdminSettingCreateDto} [userAdminSettingCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminSettingApi
     */
    public apiUserAdminSettingPost(userAdminSettingCreateDto?: UserAdminSettingCreateDto, options?: RawAxiosRequestConfig) {
        return UserAdminSettingApiFp(this.configuration).apiUserAdminSettingPost(userAdminSettingCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}

